import { Building2 } from "lucide-react";

const HeaderSection = ({ currentLang }) => {
  return (
    <div className="text-center mb-16">
      <div className="inline-flex items-center gap-2 bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200 px-4 py-2 rounded-full text-sm font-medium mb-6">
        <Building2 className="w-4 h-4" />
        {currentLang === "ar" ? "فرص استثمار" :
         currentLang === "fr" ? "Opportunités d'investissement" : "Investment Opportunities"}
      </div>
      <h1 className="text-5xl font-bold text-gray-900 dark:text-white mb-6">
        {currentLang === "ar" ? "فرص الاستثمار في جهاز مشروعات الخدمة الوطنية" :
         currentLang === "fr" ? "Opportunités d'investissement dans l'Organisation des Projets de Service National" :
         "Investment Opportunities in the National Service Projects Organization"}
      </h1>
      <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto leading-relaxed">
        {currentLang === "ar" ? "انضم إلينا في دعم وتطوير المشاريع الوطنية الرائدة في مختلف القطاعات والصناعات." :
         currentLang === "fr" ? "Rejoignez-nous pour soutenir et développer des projets nationaux de premier plan dans divers secteurs et industries." :
         "Join us in supporting and developing leading national projects across various sectors and industries."}
      </p>
    </div>
  );
};

export default HeaderSection;